import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import FileUpload from './FileUpload'
import Modal from './Modal'
import { ImportBonuses } from '../graphql/mutations'

const ImportBonusModal = ({
    show,
    close,
    onSuccess,
}) => {

    const { t } = useTranslation()
    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)
    const [importBonuses] = useMutation(ImportBonuses)

    const handleImport = async (file) => {
        setLoading(false)
        
        try {
            const res = await importBonuses({
                variables: {
                    file,
                },
            })

            if (res?.data?.importBonuses?.code === 'SUCCESS') {
                if (onSuccess) onSuccess()
                return
            }

            if (res?.data?.importBonuses?.items?.length > 0) {
                const failList = res.data.importBonuses.items.map(x => `(${x.error}) Name: ${x.name}, Sum: ${x.sum}, PID: ${x.pid}`)
                setError(`${t('bonuses.add_error')}\n\n${failList.join('\n\n')}`)
                return
            }

            setError(t('bonuses.add_error'))
        } catch (err) {
            setError(t('bonuses.add_error'))
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const handleClose = () => {
        if (close) close()
        setError(null)
    }

    return (
        <Modal
            className={'modal-bonuses'}
            show={show}
            close={handleClose}
            title={ t('bonuses.import') }
        >
            <FileUpload
                handleUpload={handleImport}
                loading={loading}
            />

            {
                error ?
                <div className='error-message'>
                    <span>{ error }</span>
                </div>
                :
                <></>
            }
        </Modal>
    )
}

export default ImportBonusModal